module.exports = __webpack_public_path__ + "static/media/soulstone-rock.2bbc917b.png";